import IconChevronLeft from '@/shared/icons/NewDesign/IconChevronLeft'
import IconChevronRight from '@/shared/icons/NewDesign/IconChevronRight'
import { PagerButton, PagerGroup, PagerPage } from '../styled-components'

interface ContractsPagerProps {
  label: string
  pageLabel: string
  previousLabel: string
  nextLabel: string
  hasPrevious: boolean
  hasNext: boolean
  onPrevious: () => void
  onNext: () => void
}

const ContractsPager = ({
  label,
  pageLabel,
  previousLabel,
  nextLabel,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
}: ContractsPagerProps) => (
  <PagerGroup aria-label={label}>
    <PagerButton type='button' disabled={!hasPrevious} onClick={onPrevious}>
      <IconChevronLeft size={15} />
      {previousLabel}
    </PagerButton>
    <PagerPage aria-live='polite'>{pageLabel}</PagerPage>
    <PagerButton type='button' disabled={!hasNext} onClick={onNext}>
      {nextLabel}
      <IconChevronRight size={15} />
    </PagerButton>
  </PagerGroup>
)

export default ContractsPager
